import BaseApi from '@/api/controller/base';

const EB_QUALIFICATION_API_URL = 'earlyBirdQualification/';

class EBQualificationApi extends BaseApi {
  constructor() {
    super(EB_QUALIFICATION_API_URL);
  }

  overrideApproval(qualification) {
    const qualificationId = qualification.id;
    if (qualificationId) {
      return this.api.post(`${qualificationId}/overrideApproval`, qualification);
    }
    return Promise.reject(Error('Please include an id with request to override EB Qualification approval.'));
  }
}

const apiInstance = new EBQualificationApi();
export { EBQualificationApi, apiInstance };
export default apiInstance;
